import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import PromoCodeForm from '@/components/v2/PromoCodeForm.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PromoCodeAdd from '@/plugins/graphql/mutations/v2/promo-code-create.gql';
import PromoCodes from '@/plugins/graphql/queries/v2/promo-codes.gql';
import { successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import PromoCodeMixin from '@/helpers/vue_mixins/v2/ecommerce/PromoCodeMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let PromoCodeCreate = class PromoCodeCreate extends Mixins(AlertMixin, RouterParamsAppMixin, PromoCodeMixin, PaginatorMixin, CleverTapEventsMixin) {
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.create(form)
            .then(() => {
            const msg = successfulCreate('Promo Code');
            this.voucherAction('SUBMIT CREATE');
            this.successNotification(msg);
            this.goToPromoCodesPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create(form) {
        const appUuid = this.appUUID;
        const { code, value, active } = form;
        return this.$apollo.mutate({
            mutation: PromoCodeAdd,
            variables: {
                input: {
                    code,
                    value,
                    usageLimit: Number(form.usageLimit),
                    startAt: new Date(`${form.startAt}T${form.startAtTime}`),
                    endAt: new Date(`${form.endAt}T${form.endAtTime}`),
                    active,
                    appUuid,
                    valueType: form.valueType,
                    minimumSpend: form.minimumSpend,
                    paymentOptions: form.applicablePaymentOption,
                    firstTime: form.firstTime,
                    stackable: !form.stackable,
                    voucherVisibility: form.voucherVisibility,
                    promotionSetting: form.promotionSetting || [],
                },
            },
            update(cache, { data }) {
                const queryOptions = {
                    query: PromoCodes,
                    variables: {
                        appUuid,
                        first: this.perPage,
                        after: null,
                    },
                };
                const { fetchAllPromoCode } = cache.readQuery({
                    ...queryOptions,
                });
                if (!fetchAllPromoCode) {
                    return;
                }
                const cachedPromoCodes = {
                    ...fetchAllPromoCode,
                };
                cachedPromoCodes.edges.unshift({
                    node: data.promoCodeAdd.promoCode,
                    __typename: 'PromoCodeEdges',
                });
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        fetchAllPromoCode: cachedPromoCodes,
                    },
                });
            },
        });
    }
};
PromoCodeCreate = __decorate([
    Component({
        components: {
            PageTitle,
            PromoCodeForm,
        },
        beforeRouteLeave(to, from, next) {
            // Connects to Store Launch Gen AI Form
            // to.name = ecommerce-promos is the normal route
            // to.name = ecommerce-store-launch via override
            if (to.name !== 'ecommerce-promos' && to.name !== 'ecommerce-store-launch') {
                this.$store.commit('resetFormData');
            }
            next();
        },
    })
], PromoCodeCreate);
export default PromoCodeCreate;
